import React from 'react';

interface StatusData {
  name: string;
  value: number;
  color: string;
}

interface CreditStatusChartProps {
  statusData: StatusData[];
}

export default function CreditStatusChart({ statusData }: CreditStatusChartProps) {
  const total = statusData.reduce((sum, item) => sum + item.value, 0);

  return (
    <div className="bg-white border rounded-lg">
      <div className="p-4 border-b">
        <h3 className="text-lg font-semibold">Distribusi Status Aplikasi</h3>
      </div>
      <div className="p-4">
        {statusData.length > 0 ? (
          <div className="flex items-center gap-6">
            {/* Simple Donut Chart */}
            <div className="relative w-[160px] h-[160px]">
              <svg viewBox="0 0 100 100" className="w-full h-full -rotate-90">
                {
                  statusData.reduce(
                    (acc, item, index) => {
                      const percentage = (item.value / total) * 100;
                      const strokeDasharray = `${percentage} ${100 - percentage}`;
                      const strokeDashoffset = -acc.offset;
                      acc.elements.push(
                        <circle
                          key={index}
                          cx="50"
                          cy="50"
                          r="40"
                          fill="none"
                          stroke={item.color}
                          strokeWidth="20"
                          strokeDasharray={strokeDasharray}
                          strokeDashoffset={strokeDashoffset}
                          className="transition-all duration-500"
                        />
                      );
                      acc.offset += percentage;
                      return acc;
                    },
                    { elements: [] as React.ReactNode[], offset: 0 }
                  ).elements
                }
              </svg>
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="text-center">
                  <p className="text-2xl font-bold">{total}</p>
                  <p className="text-xs text-gray-500">Total</p>
                </div>
              </div>
            </div>

            {/* Legend */}
            <div className="space-y-3">
              {statusData.map(item => (
                <div key={item.name} className="flex items-center gap-3">
                  <div className="w-3 h-3 rounded-full" style={{ backgroundColor: item.color }} />
                  <div>
                    <p className="text-sm font-medium">{item.name}</p>
                    <p className="text-xs text-gray-500">{item.value} aplikasi</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="h-[200px] flex items-center justify-center text-gray-500">
            Belum ada data aplikasi
          </div>
        )}
      </div>
    </div>
  );
}
